//generic
export const CRH = "Capital repayment holiday";
export const CIRH = "Capital & Interest repayment holiday";
//RequestRepaymentHolidayHeader
export const REPAYMENT_HOLIDAY_HEADING = "Request repayment holiday";
export const REPAYMENT_HOLIDAY_TITLE2 =
  "Two types of repayment holidays are available";
export const REPAYMENT_HOLIDAY_TITLE2_SUB1 = "Capital repayment holiday";
export const REPAYMENT_HOLIDAY_TITLE2_SUB2 =
  "Capital & Interest repayment holiday";
//RepaymentHolidayOptions
export const REPAYMENT_HOLIDAY_OPTION_LABEL =
  " Select an option for further details";
export const REPAYMENT_HOLIDAY_OPTION_CRH_TEXT =
  "You reduce your repayments for 6 months by making interest only payments";
export const REPAYMENT_HOLIDAY_OPTION_CIRH_TEXT =
  "You will not make any repayments for 6 months";
//CRH/CIRH ChoicesExplained
export const CRH_CHOICES_HEADING =
  "You have selected a Capital repayment holiday";
export const CHOICES_TITLE = "You now have two choices:";
export const ONE_CHOICE_TITLE = "You now have this option:";
export const CRH_CHOICE_TEXT =
  " Take a little longer to repay your loan so that the amount that you pay each month is still the same when your Capital repayment holiday ends";
export const CRH_CHOICES_TEXT1 =
  " Take a little longer to repay your loan so that the amount that you pay each month is still the same when your Capital repayment holiday ends – select Option 1";
export const CRH_CHOICES_TEXT2 =
  " Keep the term of your loan the same as today and pay a larger amount each month when your Capital repayment holiday ends – select Option 2";
export const CHOICES_NOTE =
  "If you choose Option 1 you will pay more interest than Option 2";
export const CIRH_CHOICES_HEADING =
  "You have selected a Capital & Interest repayment holiday";
export const CIRH_CHOICES_TITLE =
  "Your monthly repayments will be larger after your Capital & Interest repayment holiday";
export const CIRH_CHOICES_TEXT1 =
  "Take a little longer to repay your loan so that the amount that you pay each month increases by a small amount when your Capital & Interest repayment holiday ends – select Option 1";
export const CIRH_CHOICE_TEXT =
  "Take a little longer to repay your loan so that the amount that you pay each month increases by a small amount when your Capital & Interest repayment holiday ends";
export const CIRH_CHOICES_TEXT2 =
  "Keep the term of your loan the same as today and pay a larger amount each month when your Capital & Interest repayment holiday ends – select Option 2";
//CRH/CIRH options
export const CRH_OPTIONS_HEADING =
  "Select one option for a Capital repayment holiday:";
export const CIRH_OPTIONS_HEADING =
  "Select one option for a Capital & Interest repayment holiday:";
export const CRH_OPTION_HEADING =
  "Select below option for a Capital repayment holiday:";
export const CIRH_OPTION_HEADING =
  "Select below option for a Capital & Interest repayment holiday:";
export const CRH_EXTEND_TERM =
  "Pay the same each month by extending your loan term by 6 months";
export const CRH_WITHOUT_EXTEND_TERM =
  "Pay more each month and keep the same loan term";
export const CIRH_EXTEND_TERM =
  "Pay a small increase each month by extending your loan term by 6 months";
export const CIRH_WITHOUT_EXTEND_TERM =
  "Pay more each month and keep the same loan term";
//Important Information
export const IMORTANT_INFO_HEADING = "Important Information";
export const IMORTANT_INFO_TEXT2 = "Overall you will pay more interest";
export const IMORTANT_INFO_TEXT4 =
  "Repayment holidays won't impact your credit rating, but lenders may take them into account on future lending decisions";
export const IMPORTANT_INFO_NOTE =
  "These changes will only happen after you sign the documentation to amend your Bounce Back Loan agreement. We will send this to you by encrypted email within 2 business days if you decide to go ahead unless we otherwise inform you that there is a reason we can’t proceed with your application.";
//
export const IMPORTANT_INFO_NOTE_PARA_1 = `These changes will only happen after you sign the documentation to amend your Bounce Back loan agreement. In the majority of cases, we will send the documentation to you via encrypted email within 2 business days if you decide to go ahead, unless we otherwise inform you that there is a reason we can't proceed with your application.`;
export const IMPORTANT_INFO_NOTE_PARA_2 = `However, if a payment was due in the last few days, we will need to run some additional checks to see if you are currently up to date with your payments. In these cases, you will have your documentation within 10 calendar days if you decide to go ahead.`;
export const IMPORTANT_INFO_NOTE_PARA_3 = `If you have been found to have missed a payment, we will include this missed payment in calculating your monthly repayment and this may result in a higher monthly repayment in the documentation from what is displayed here. `;
export const IMPORTANT_INFO_NOTES = [
  IMPORTANT_INFO_NOTE_PARA_1,
  IMPORTANT_INFO_NOTE_PARA_2,
  IMPORTANT_INFO_NOTE_PARA_3,
];
//CRH Important Information
export const CRH_IMORTANT_INFO_TITLE =
  "Before you take a 6 month Capital repayment holiday, please ensure you understand the impact on your loan.";

export const CRH_EXTEND_TERM_IMORTANT_INFO_TEXT3 =
  "After the Capital repayment holiday ends your monthly repayment will stay the same";
export const CRH_IMORTANT_INFO_TEXT3 =
  "After the Capital repayment holiday ends your monthly repayments will be larger";

export const CRH_CHKBOX_TEXT =
  "I have read the important information and I wish to go ahead with this Capital repayment holiday";
export const CRH_EXTEND_TERM_CHKBOX_TEXT =
  "I have read the important information and I wish to go ahead with this Capital repayment holiday and extend my loan by 6 months";

//CIRH Important Information
export const CIRH_IMORTANT_INFO_TITLE =
  "Before you take a 6 month Capital & Interest repayment holiday, please ensure you understand the impact on your loan.";
export const CIRH_IMORTANT_INFO_TEXT3 =
  "After the Capital & Interest repayment holiday ends your monthly repayment will be larger";

export const CIRH_EXTEND_TERM_CHKBOX_TEXT =
  "I have read the important information and I wish to go ahead with this Capital & Interest repayment holiday and extend my loan by 6 months";
export const CIRH_CHKBOX_TEXT =
  "I have read the important information and I wish to go ahead with this Capital & Interest repayment holiday";

//Extend term active - Repayment holiday requested
//Choices Explained

export const RH_TEXT =
  "The length of your loan has been extended to the maximum possible";
export const RH_CRH_CHOICES_TEXT1 =
  "You reduce your repayments for 6 months by making interest only payments";
export const RH_CRH_CHOICES_TEXT2 =
  "Pay a larger amount each month when your Capital repayment holidays ends - select Option 1";
export const RH_CIRH_CHOICES_TEXT1 =
  "You will not make any repayments for 6 months";
export const RH_CIRH_CHOICES_TEXT2 =
  "Pay slightly more thank option 1 each month when your Capital & Interest repayment holidays ends - select Option 2";
export const RH_CHOICES_NOTE =
  "If you choose Option 1 you will pay less interest than Option 2";
export const RH_OPTIONS_HEADING = "Select one option for a repayment holiday:";
export const RH_CRH = "Capital repayment holiday - pay more each month";
export const RH_CIRH =
  "Capital & Interest repayment holiday - pay slightly more each month";

export const ONE_RH_OPTION_VISIBLE = `As you have already taken some repayment holidays and extended the length of your loan to the maximum possible this is the only repayment holiday still available to you:`;
